import { ExportService } from 'src/app/_services/export.service';
import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from './../../../../_config/config';


@Injectable({
  providedIn: 'root'
})
export class GraphicService {

  gateway = this.config.gateway;
  urlConsulta= `${this.gateway.urlQuery}/lbw/consulta`;
  urlReports= `${this.gateway.urlReport}/lbw/reportes`;

  constructor(private http: HttpClient,
              private config: CONFIG,
              private exportService: ExportService) { }

  onGetJasper(reportid: string, args: any, format:string, queryid:string) {
      args.LOGON_NAME = sessionStorage.getItem('logonName');
      const bodyparams = {
        "reportName": reportid,
        "parameters": args,
        "queryid": queryid
      };
      console.log('exportJasper' , bodyparams);
      return this.http.post(`${this.urlReports}/export/${format}`, bodyparams, { responseType: "arraybuffer" });
    }

    executeReport(report, format, title) {
      return this.exportService.executeReport (report, format, title);
    }

   onGetDataGrafic(data, param){
     let object = {
      data: data,
      filter: param
     }
     return this.http.post(`${this.urlConsulta}/query/parametersGrafic`, object);
  }

  onGetComponentPetrofisica(queryid, listArguments){
    let argFind = listArguments.find(item => item.argid === '[atributos]' ) ;
    let object = {
      queryId: queryid,
      level: 0,
      atributos: argFind.argdata.replaceAll("'",'').split(','),
      args: listArguments
     }
    return this.http.post(`${this.urlConsulta}/query/getPetrofisicaComponentes1`, object);
  }

}
